import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useConsent } from '@/shared/contexts/ConsentContext';
import { isGaConfigured, loadGoogleAnalytics, trackPageView } from './gaClient';

/**
 * Loads GA4 only after the user grants analytics consent (GDPR-compliant), then
 * reports SPA page views on route changes. Renders nothing. Inert unless
 * `VITE_GA_MEASUREMENT_ID` is configured, so it is safe to mount unconditionally.
 *
 * Mount inside both <Router> (for useLocation) and <ConsentProvider> (for
 * useConsent) — e.g. next to <CookieConsentBanner/> in App.tsx.
 */
export function GoogleAnalytics() {
  const { analyticsAllowed } = useConsent();
  const location = useLocation();

  // Load gtag once, only after consent is granted.
  useEffect(() => {
    if (analyticsAllowed && isGaConfigured()) {
      loadGoogleAnalytics();
    }
  }, [analyticsAllowed]);

  // Report a page view on each navigation (and on first load after consent).
  useEffect(() => {
    if (analyticsAllowed && isGaConfigured()) {
      trackPageView(location.pathname + location.search);
    }
  }, [analyticsAllowed, location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;
